import type { Severity } from '@studio/design-system/messaging';
import { Tag } from '@studio/design-system/tag';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

const severity: Severity[] = ['info', 'success', 'warning', 'error'];

/** `<Buttons>` exhibit. */
export const Tags = (): ReactElement => (
  <Exhibit title='Buttons'>
    <Column className='items-stretch gap-40 bg-transparent'>
      <h1>Badges go here.</h1>
      {severity.map((s) => (
        <div className='flex items-center gap-8' key={s}>
          <span className='flex-1'>{s}: </span>
          <div>
            <Tag className='flex-1' message='hello' severity={s} />
          </div>
        </div>
      ))}
    </Column>
  </Exhibit>
);
